import { Directive, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IChartData, ImmomioIconName } from '../../models';

@UntilDestroy()
@Directive()
export class RentalCostLegendBaseComponent {
  @Input() data: IChartData;
  @Input() caption: string;
  @Input() valuesAreMoney: boolean;
  public immomioIconName = ImmomioIconName;
}
